import { render, staticRenderFns } from "./MetricWidget.vue?vue&type=template&id=160e4b48&scoped=true"
import script from "./MetricWidget.vue?vue&type=script&lang=js"
export * from "./MetricWidget.vue?vue&type=script&lang=js"
import style0 from "./MetricWidget.vue?vue&type=style&index=0&id=160e4b48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "160e4b48",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VIcon,VProgressLinear})
